import * as React from 'react';
import AppConfig from '../../Configs/AppConfig';
import logoLMS from '../../Assets/images/logoLMS.svg';
import logoAt from '../../Assets/images/logoCLat.svg';
import logoPH from '../../Assets/images/logoProducthouse.svg';
import logoVisuality from '../../Assets/images/logoVisuality.png';
import { get } from 'lodash';

export enum LOGO_OPTION {
  CL_visuality = 'CL_visuality',
  CL_at = 'CL_at',
  CL_producthouse = 'CL_producthouse',
}

export const LogoSrcProvider = (): React.ReactElement => {
  const LOGO = get(AppConfig, 'LOGO');

  switch (LOGO) {
    case LOGO_OPTION.CL_producthouse:
      return <img alt="logo-producthouse" height={56} src={logoPH} />;

    case LOGO_OPTION.CL_visuality:
      return <img alt="logo-visuality" width={40} src={logoVisuality} />;

    case LOGO_OPTION.CL_at:
      return <img alt="logo-coders-lab" width={150} src={logoAt} />;

    default:
      return <img alt="logo-coders-lab" src={logoLMS} />;
  }
};
